import {FnExceptionService} from '../exception/fn-exception.service';

export abstract class FnClickListner {
  constructor(private excptionSvcs: FnExceptionService) {
  }

  click(eventId: string, ...restParams: any[]) {
    try {
      const t0 = performance.now();
      this.execute(eventId, restParams);
      const t1 = performance.now();
      console.log('Call to execute took ' + (t1 - t0) + ' milliseconds.');
    } catch (e) {
      this.excptionSvcs.logException(e);

      // throw new Error(e);
    }

  }

  abstract execute(eventId: string, restParams:any):any;
}
